import _ from 'lodash'
import React, { ReactNode, useEffect, useState } from 'react'

import Notification, { NotificationTypes } from './Notification'

export interface INotification {
    message: ReactNode
    autoClose?: boolean
    type: NotificationTypes
    key?: number
}
interface INotificationsManagerProps {
    notification: INotification
}

export default function NotificationsManager({ notification }: INotificationsManagerProps): React.ReactNode {
    const [notifications, setNotifications] = useState<INotification[]>([])

    useEffect(() => {
        const noOfNotifications = notifications.length
        if (notifications.length === 3) notifications.shift()

        const newNotifications = _.uniq([...notifications, { ...notification, key: noOfNotifications + 1 }])

        setNotifications(newNotifications)
    }, [notification])

    const deleteNotification = () => {
        const test = _.minBy(notifications, 'key')
        const newNotifications = notifications.filter((n) => n.key !== test?.key)

        setNotifications(newNotifications)
    }

    return notifications.map((notification, i) => (
        <Notification
            autoClose={notification.autoClose}
            onDismiss={() => deleteNotification()}
            key={i}
            index={notification.key}
            message={notification?.message}
            type={notification?.type}
        />
    ))
}
